<template>
    <!-- 프로그래스바 -->
    <div class="gmx_progress_wrap flex flex_column">
        <slot name="title">
            <span class="gmx_progress_title" v-if="title">{{ title }}</span>
        </slot>
        <div class="gmx_progress_header flex flex_space_1">
            <span class="gmx_progress_value">{{ data.achiveRate }}%</span>
            <div class="gmx_progress_text">
                <span>{{ data.ordersPay }}</span>
                <span>
                    / {{ data.targetPay }} 백만원
                </span>
            </div>
        </div>
        <div class="gmx_progress_bar">
            <div :style="`width: ${data.achiveRate > 100 ? 100 : data.achiveRate}%`"></div>
        </div>
    </div>
</template>
  
<script setup>
import { defineProps} from 'vue';
  defineProps({
        data : {
            type: Object
        },
        title: {
            type: String,
            default: ''
        },
        percent : {
            type: Number,
            default : 50
        },
        unit : {
            type: String,
            default: '10,000 백만원'
        },
        val : {
            type: Number,
            default: 230
        }
  });

</script>

<style lang="scss" scoped>
    .gmx_progress_wrap {
        width: 100%;
        margin: 12px 0;
        .gmx_progress_title {
            margin-bottom: 12px;
            font-size: $font-size2;
        }
        .gmx_progress_value {
            color: $gmx-main-color;
            font-family: "PretendardSemiBold";
        }
        .gmx_progress_bar {
            height: 14px;
            background-color: $gmx-box-sub-bg-color;
            border-radius: $border-radius4;
            >div {
                height: 100%;
                background-color: $gmx-main-color;
                border-radius: $border-radius4;
            }
        }
        .gmx_progress_text {
            text-align: right;
            >span:first-child {
                font-family: "PretendardSemiBold";
                font-size: $font-size2;
                color: $gmx-font-color;
            }
            >span:last-child {
                font-size: $font-size0;
                color: $gmx-font-sub-color2;
            }
        }
    }
</style>